import axios from "axios";

import { SimpleCache } from "./cache";

export const defaultApiUrl =
  window.location.href.indexOf("8080") !== -1
    ? "http://localhost:8000/api/"
    : "https://api.scalene.fr/api/";

const cli = axios.create({
  baseURL: process.env.VUE_APP_API_URL || defaultApiUrl
});

export const setToken = token => {
  if (cli.defaults.headers.common["X-API-TOKEN"]) return;
  cli.defaults.headers.common["X-API-TOKEN"] = token;
};

const cache = new SimpleCache();

const api = {
  get(url, data, token) {
    setToken(token);
    return cache.get(`${url}`, () =>
      cli.get(`${url}`, { params: { ...data } })
    );
  },
  client() {
    return cli;
  },
  post(url, data, token) {
    setToken(token);
    return cli.post(`${url}`, { data });
  },
  put(url, data, token) {
    setToken(token);
    return cli.put(`${url}`, { data });
  },
  delete(url, data, token) {
    setToken(token);
    return cli.delete(`${url}`, { params: { ...data } });
  },
  nget(url, data) {
    return cli.get(`${url}`, { params: { ...data } });
  },
  npost(url, data) {
    return cli.post(`${url}`, { ...data });
  },
  nput(url, data) {
    return cli.put(`${url}`, { ...data });
  },
  ndelete(url, data) {
    return cli.delete(`${url}`, { params: { ...data } });
  },
  upload(url, file, token) {
    console.log(file);
    setToken(token);
    const formData = new FormData();
    formData.append("payload", file);
    return cli.post(url, formData, {
      headers: { "content-type": "multipart/form-data" }
    });
  }
};

export default api;

const apithing = thing => async (...args) => {
  try {
    const { data } = await api[thing](...args);
    return data;
  } catch (e) {
    throw e;
  }
};

export const apiget = apithing("get");
export const apipost = apithing("post");
export const apiput = apithing("put");
export const apidel = apithing("delete");
export const apiupload = apithing("upload");
export const client = api.client;
